import { get, set, del, keys, clear } from "idb-keyval";
import type { Template } from "@/types/template";
import type { Evaluation } from "@/types/evaluation";

const TEMPLATE_PREFIX = "template:";
const EVALUATION_PREFIX = "eval:";

export async function saveTemplate(template: Template): Promise<void> {
  await set(TEMPLATE_PREFIX + template.id, template);
}

export async function deleteTemplate(id: string): Promise<void> {
  await del(TEMPLATE_PREFIX + id);
}

export async function getAllTemplates(): Promise<Template[]> {
  const allKeys = await keys();
  const templateKeys = allKeys.filter(
    (k) => typeof k === "string" && k.startsWith(TEMPLATE_PREFIX),
  );
  const templates = await Promise.all(templateKeys.map((k) => get<Template>(k)));
  return templates.filter((t): t is Template => t !== undefined);
}

export async function saveEvaluation(evaluation: Evaluation): Promise<void> {
  await set(EVALUATION_PREFIX + evaluation.id, evaluation);
}

export async function deleteEvaluation(id: string): Promise<void> {
  await del(EVALUATION_PREFIX + id);
}

export async function getAllEvaluations(): Promise<Evaluation[]> {
  const allKeys = await keys();
  const evalKeys = allKeys.filter((k) => typeof k === "string" && k.startsWith(EVALUATION_PREFIX));
  const evaluations = await Promise.all(evalKeys.map((k) => get<Evaluation>(k)));
  return evaluations.filter((e): e is Evaluation => e !== undefined);
}

export async function clearAll(): Promise<void> {
  await clear();
}
